"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var AppMargins_1 = require("../../../app/components/AppMargins");
var fullScreenDialog_1 = __importDefault(require("../../helpers/fullScreenDialog"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        modalMargins: {
            marginLeft: theme.spacing(6.25),
            marginRight: function (props) {
                return props.applyRightMargin ? theme.spacing(6.25) : 0;
            },
        },
    });
});
var ModalMargins = function (_a) {
    var applyRightMargin = _a.applyRightMargin, children = _a.children;
    var classes = useStyles({ applyRightMargin: applyRightMargin });
    var isFullScreenDialog = fullScreenDialog_1.default();
    // Use app margins in full screen dialogs.
    if (isFullScreenDialog) {
        return react_1.default.createElement(AppMargins_1.ApplyAppMargins, null, children);
    }
    return react_1.default.createElement("div", { className: classes.modalMargins }, children);
};
ModalMargins.defaultProps = {
    applyRightMargin: true,
};
exports.default = ModalMargins;
